module.exports = {"130372001":"南戴河街道","130372400":"大蒲河管理处","130372401":"团林管理处","130372402":"留守营管理处"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130372.json
// module id = 108
// module chunks = 0